import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./FilterPanel.css";

const FilterPanel = ({ onFilterChange }) => {
  const [selectedType, setSelectedType] = useState("All");
  const [selectedRange, setSelectedRange] = useState("Today");
  const [customRange, setCustomRange] = useState({ from: "", to: "" });

  const handleTypeClick = (type) => {
    setSelectedType(type);
    triggerChange(type, selectedRange, customRange);
  };

  const handleRangeClick = (range) => {
    setSelectedRange(range);
    if (range !== "Custom") {
      setCustomRange({ from: "", to: "" });
      triggerChange(selectedType, range, {});
    }
  };

  const handleCustomChange = (field, value) => {
    const updated = { ...customRange, [field]: value };
    setCustomRange(updated);
    triggerChange(selectedType, "Custom", updated);
  };

  const triggerChange = (type, range, custom) => {
    onFilterChange && onFilterChange({ type, range, custom });
  };

  return (
    <div className="filter-panel d-flex flex-wrap align-items-center gap-2">
      {/* Transaction Type Pills */}
      {["All", "Transaction", "Withdraw", "Refund"].map((type) => (
        <button
          key={type}
          className={`btn btn-sm rounded-pill fw-semibold filter-btn ${
            selectedType === type
              ? `active-${type.toLowerCase()}`
              : type.toLowerCase()
          }`}
          onClick={() => handleTypeClick(type)}
        >
          {type}
        </button>
      ))}

      <div className="vr mx-2" />

      {/* Date Range Pills */}
      {["Today", "This Week", "This Month", "This Year", "Custom"].map(
        (range) => (
          <button
            key={range}
            className={`btn btn-sm rounded-pill fw-semibold date-btn ${
              selectedRange === range ? "active-date" : ""
            }`}
            onClick={() => handleRangeClick(range)}
          >
            {range}
          </button>
        )
      )}

      {/* Custom Range Fields */}
      {selectedRange === "Custom" && (
        <div className="d-flex align-items-center ms-2 gap-1">
          <input
            type="date"
            value={customRange.from}
            onChange={(e) => handleCustomChange("from", e.target.value)}
            className="form-control form-control-sm"
          />
          <span className="mx-1">→</span>
          <input
            type="date"
            value={customRange.to}
            onChange={(e) => handleCustomChange("to", e.target.value)}
            className="form-control form-control-sm"
          />
        </div>
      )}
    </div>
  );
};

export default FilterPanel;
